export const BOLD_BUTTON_DATA_HOOK = 'textInlineStyleButton_Bold';
